import { ButtonLink } from '@designsforhealth/dfh-react-components'
import React, { useCallback } from 'react'
import styled from 'styled-components'

import { useAccountsUrl } from '../../lib/accounts'
import { RegisterType } from '../../lib/accounts/types'

export interface RegistrationLinkProps {
  className?: string
  registerType?: RegisterType
}

const RegistrationLink: React.FC<RegistrationLinkProps> = ({
  children,
  className,
  registerType,
}) => {
  const { redirectToAccount } = useAccountsUrl()

  const onClick = useCallback(() => {
    redirectToAccount({
      page: 'register',
      registerType,
    })
  }, [redirectToAccount, registerType])

  return (
    <ButtonLink className={className} onClick={onClick}>
      {children}
    </ButtonLink>
  )
}

const StyledRegistrationLink = styled(RegistrationLink)``

export default StyledRegistrationLink
